import { useQuery } from '@tanstack/react-query';
import { getProduct } from '../services/products.api';

export function useProduct(id: string) {
  return useQuery({
    queryKey: ['products', 'detail', id],
    queryFn: () => getProduct(id),
    enabled: Boolean(id),
  });
}
